import {gql} from '@apollo/client';

const GET_BUS_PARTNER_AND_COUNTRY_COST_ENTRY_YEAR = gql`
  query getBusPartnerAndCountryCostEntryYear(
    $busPartnerId: ID!
    $year: Int!
    $countryId: ID!
  ) {
    getBusPartnerCostEntryYear(busPartnerId: $busPartnerId, year: $year) {
      year
      qualityChecked
      qualityCheckedLastEditedAt
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        year
        busTypeId
        leasingCost
        interestCost
        insuranceCost
        motorVehicleTax
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        vehicleRegistrationCost
        customIdentifier
        vehicleProductionYear
      }
      driverCostEntry {
        year
        daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        replacementCostPerKm
        replacementCostPerHr
        accommodationCostPerNight
      }
    }

    countryCostEntry(countryId: $countryId, year: $year) {
      year
      busCostEntry {
        adblueCost
        cleaningCost
        currency
        dieselCost
        flixStandardCost
        legalCost
        lngCost
        otherCost
        overheadCost
        repairCostPerDistanceUnit
        repairCostPerMonth
        tiresCost
        year
      }
      busTypeCostEntries {
        id
        year
        busTypeId
        leasingCost
        interestCost
        insuranceCost
        motorVehicleTax
        maintenanceCostPerMonth
        maintenanceCostPerDistanceUnit
        vehicleRegistrationCost
        customIdentifier
        vehicleProductionYear
      }

      driverCostEntry {
        year
        daytimeWeekdaysWorkingHourCost
        daytimeWeekendsWorkingHourCost
        nighttimeWeekdaysWorkingHourCost
        nighttimeWeekendsWorkingHourCost
        replacementCostPerKm
        replacementCostPerHr
        accommodationCostPerNight
        dailyAllowance
        prefilledEmptyDistance
        prefilledEmptyHr
      }

      qualityChecked
    }
  }
`;

export default GET_BUS_PARTNER_AND_COUNTRY_COST_ENTRY_YEAR;
